import { Users } from "lucide-react";

import { cn } from "@/utils/cn";

import { TOKENS_ICON } from "../plan-hub.constants";
import type { PlanResourceKey } from "../types";

interface PlanResourceIconProps {
  resource: PlanResourceKey;
  /** Rendered size in px. */
  size: number;
  className?: string;
}

/**
 * Tokens are always the gold coin mark — the app's established AI-token
 * visual — so the pill and the panel can never drift apart. Seats stay a
 * line icon tinted by the caller.
 */
export const PlanResourceIcon = ({
  resource,
  size,
  className,
}: PlanResourceIconProps) => {
  if (resource === "tokens") {
    return (
      <img
        src={TOKENS_ICON}
        alt=""
        aria-hidden
        draggable={false}
        width={size}
        height={size}
        className={cn("shrink-0 object-contain", className)}
        style={{ width: size, height: size }}
      />
    );
  }

  return <Users size={size} className={cn("shrink-0", className)} />;
};
